import AdvancedController from "./advanced-controller"


export default class SingleDownloadController extends AdvancedController {

  static targets = [
    'wrapper',
  ];


  connect() {
    super.connect();
    this.startCountdown();
  }

  startCountdown() {
    setTimeout(this.startDownload.bind(this), 6000);

    var timeleft = 5;
    document.getElementById("countdown").innerHTML = timeleft;
    var downloadTimer = setInterval(function () {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        document.getElementById("countdown").innerHTML = timeleft;
        document.getElementById("progressBar").value = 5;

      } else {
        document.getElementById("countdown").innerHTML = timeleft;
        document.getElementById("progressBar").value = 5 - timeleft;
      }
      timeleft -= 1;
    }, 1000);
  }

  startDownload() {
    let downloadFileButton = this.wrapperTarget.querySelector('.download-file-btn');
    if (downloadFileButton) {
      downloadFileButton.click()
    }
  }

}
